import {
  brandSchemeData,
  brandStyleData,
  determineWhetherThePlanIsSuccessful,
  generateAnImage,
  schemeContinueImage,
  schemeDeleteImage,
  serBrandProductsList,
  serBuildAScenario,
  serMaterialList,
} from '@/services/AssistantInfo';
import { useModel, useParams, useRequest } from '@umijs/max';
import { cloneDeep } from 'lodash';
import { useEffect, useRef, useState } from 'react';

export default function () {
  const { id } = useParams();
  const formRef = useRef();
  const { pageId } = useModel('AssistantInfo.assistantInfo');
  const [currentSteps, setCurrentSteps] = useState<number>(0);
  const [createData, setcreateData] = useState<any>({});
  const [brandSchemeInfo, setBrandSchemeInfo] = useState<any>({
    brandList: [],
    materialList: [],
    marketingSceneList: [],
  });
  const [brandStyleInfo, setBrandStyleInfo] = useState<any>([]);
  const [productList, setProductList] = useState<any>([]);
  const [materialList, setMaterialList] = useState<any>([]);
  const [planDetails, setPlanDetails] = useState<any>([]);

  const {
    loading: schemeContinueImageIng,
    run: handleSchemeContinueImage,
    fetches: schemeContinueImageIngs,
    cancel: handleSchemeContinueImageCancel,
  } = useRequest(schemeContinueImage, {
    manual: true,
    fetchKey: ({ schemeId }) => schemeId,
    onSuccess: (result, params) => {
      if (result.status === 0) {
        setPlanDetails((pre: any) => {
          const list = pre.map((item: any) => {
            if (item.id === params[0].schemeId) {
              if (item.imageUrls?.length > 5) {
                const detetItem = item.imageUrls.pop();
                schemeDeleteImage(detetItem.id);
              }
              item.imageUrls.unshift({
                ...result.payload,
                schemeImage: result.payload.image,
              });
            }
            return item;
          });
          return list;
        });
      }
    },
  });

  const {
    loading: generateAnImageIng,
    run: handleGenerateAnImage,
    fetches: generateAnImageIngs,
    cancel: handleGenerateAnImageCancel,
  } = useRequest(generateAnImage, {
    manual: true,
    fetchKey: ({ schemeId }) => schemeId,
    onSuccess: (result, params) => {
      if (result.status === 0) {
        setPlanDetails((pre: any) => {
          const list = pre.map((item: any) => {
            if (item.id === params[0].schemeId) {
              item.imageUrls = [...result.payload];
            }
            return item;
          });
          if (list.every((item) => item?.imageUrls)) {
            determineWhetherThePlanIsSuccessful({
              id: list[0].parameterId,
              list: cloneDeep(list),
            });
          }
          return list;
        });
      }
    },
  });

  const {
    loading: serBuildAScenarioIng,
    run: handleSerBuildAScenario,
    cancel: handleSerBuildAScenarioCancel,
  } = useRequest(serBuildAScenario, {
    manual: true,
    onSuccess: (result) => {
      if (result.status === 0) {
        setCurrentSteps(1);
        setPlanDetails(result?.payload?.filter((item) => item.id));
      }
    },
  });

  const { run: handleBrandProductsList } = useRequest(serBrandProductsList, {
    manual: true,
    throttleInterval: 800,
    onSuccess: (result) => {
      if (result.status === 0) {
        const { records } = result.payload;
        setProductList(records);
      }
    },
  });

  const { run: handleMaterialList } = useRequest(serMaterialList, {
    manual: true,
    debounceInterval: 800,
    onSuccess: (result) => {
      if (result.status === 0) {
        const { records } = result.payload;
        setMaterialList(records);
      }
    },
  });

  const { run: handleBrandSchemeData } = useRequest(brandSchemeData, {
    manual: true,
    debounceInterval: 800,
    onSuccess: (result) => {
      if (result.status === 0) {
        setBrandSchemeInfo(result.payload);
      }
    },
  });
  const { run: handleBrandStyleData } = useRequest(brandStyleData, {
    manual: true,
    debounceInterval: 800,
    onSuccess: (result) => {
      if (result.status === 0) {
        setBrandStyleInfo(result.payload);
      }
    },
  });

  useEffect(() => {
    if (currentSteps === 1) {
      const promises = planDetails.map((item: any) => {
        return handleGenerateAnImage({
          id: item.id,
          schemeId: item.id,
          assistantId: pageId,
          productsName: createData.productsName,
          materialName: createData.materialName,
          product_concept: item.creative_description,
          serviceRequest: createData.serviceRequest,
          brandName: createData.brandName,
        });
      });
      Promise.all(promises)
        .then((results) => {
          // determineWhetherThePlanIsSuccessful({
          //   id: planDetails[0].parameterId,
          //   list: cloneDeep(planDetails),
          // });
          // 处理所有的结果
        })
        .catch((error) => {
          // 处理错误
        });
    }
  }, [currentSteps]);

  return {
    currentSteps,
    setCurrentSteps,
    handleSerBuildAScenario,
    serBuildAScenarioIng,
    createData,
    setcreateData,
    handleBrandProductsList,
    productList,
    handleMaterialList,
    materialList,
    setMaterialList,
    planDetails,
    handleSchemeContinueImage,
    schemeContinueImageIng,
    schemeContinueImageIngs,
    brandSchemeInfo,
    setBrandSchemeInfo,
    handleBrandSchemeData,
    brandStyleInfo,
    setBrandStyleInfo,
    handleBrandStyleData,
    formRef,
    setPlanDetails,
    setProductList,
    generateAnImageIng,
    handleGenerateAnImage,
    generateAnImageIngs,
    handleGenerateAnImageCancel,
    handleSchemeContinueImageCancel,
    handleSerBuildAScenarioCancel,
  };
}
